import { render } from "./ScrollableDocument.vue?vue&type=template&id=594da5dc"
import script from "./ScrollableDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollableDocument.vue?vue&type=script&setup=true&lang=js"

import "./ScrollableDocument.vue?vue&type=style&index=0&id=594da5dc&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ScrollableDocument.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "594da5dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('594da5dc', __exports__)) {
    console.log('reload')
    api.reload('594da5dc', __exports__)
  }
  
  module.hot.accept("./ScrollableDocument.vue?vue&type=template&id=594da5dc", () => {
    console.log('re-render')
    api.rerender('594da5dc', render)
  })

}


export default __exports__